import React, { useState } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

import { IsSmallScreen } from "../../commonFunctions/CommonFunctions";
import WSBottomNav from "../AppBar/WSAppBar";
import { Email, Storefront, Settings } from "@mui/icons-material";
import Navbar2 from "./Navbar2";
import Sidebar2 from "./Sidebar2";
import { getMenu } from '../../Components/Dashboard/menu'
import BottomNavContainer from "../AppBar/WSAppBar";
const DashboardLayout: React.FC = () => {
  // Define color variables
 const primaryColor = "2px solid #CEEEE5";
  const secondaryColor = "0 0 8px 2px  #CEEEE5";
  const hoverColor = "#FFFFFF";
  const iconColor = "#828584";
  const textColor = "#828584";
  const hoverTextColor = "#098963";
  const backgroundColor = "#fff";
  const selectedBackgroundColor = "red";
  const boxShadowColor = "rgba(209, 200, 200, 0.6)";

  const isMobile = IsSmallScreen();

  const [open, setOpen] = useState(true);
  const [collapse, setCollapse] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const handleCollapse = () => {
    setCollapse(!collapse);
  };

  const handleProfileMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const myNavItems = [
    { path: "/email", icon: <Email />, label: "Email" },
    { path: "/store", icon: <Storefront />, label: "Store" },
    { path: "/settings", icon: <Settings />, label: "Settings" }
  ];

  return (
    <Box sx={{ display: "flex", height: "100vh", width: '100%' }}>
      {!isMobile && <Navbar2
        anchorEl={anchorEl}
        handleCollapse={handleCollapse}
        collapse={collapse}
      />}

      {!isMobile && <Sidebar2
        collapse={collapse}
        handleCollapse={handleCollapse}
        handleDrawerToggle={handleDrawerToggle}
        open={open}
        // bellow for color changes
        backgroundColor={backgroundColor}
        boxShadowColor={boxShadowColor}
        hoverColor={hoverColor}
        hoverTextColor={hoverTextColor}
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
        selectedBackgroundColor={selectedBackgroundColor}
        textColor={textColor}
        iconColor={iconColor}
      />}

      {/* Main Content */}
      <Box
        sx={{
          flexGrow: 1,
          marginTop: isMobile ? undefined : "5rem", // Offset for AppBar height
          overflowY: "auto", // Enable scrolling for content only
          marginLeft: !isMobile ? collapse ? "5rem" : "15rem" : undefined,
          // marginRight: collapse ? "3rem" : "3rem",

          // backgroundColor: "#EAEAF8" // Default background color
        }}
      >
        <div style={{ padding: 10,marginTop:0 }}>
          <Outlet />
        </div>
      </Box>

      {isMobile && <BottomNavContainer userType="ss" />}
    </Box>
  );
};

export default DashboardLayout;
